/* global location, XMLHttpRequest */

function getUrlParams() {
  var paramMap = {};

  if (location.search.length === 0) {
    return paramMap;
  }

  var parts = location.search.substring(1).split('&');

  for (var i = 0; i < parts.length; i++) {
    var component = parts[i].split('=');

    paramMap[decodeURIComponent(component[0])] = decodeURIComponent(
      component[1]
    );
  }

  return paramMap;
}

var params = getUrlParams();

var clientid = params['clientid'];

var optouttoken = params['optouttoken'];

var data = new FormData();

data.append('data', clientid);

data.append('data', optouttoken);

var xhr = new XMLHttpRequest();

xhr.onreadystatechange = function () {
  if (this.readyState === 4) {
    // NR - Empty branch commented out to ignore linter warning about unused branch
    // if (this.status !== 200) {
    // }
  }
};

xhr.open(
  'POST',
  '/emailoptout?clientid=' + clientid + '&optouttoken=' + optouttoken,
  true
);

xhr.send(data);
